import { General } from "@/services/General";
import { MainVar } from "@/entity/MainVar";
import axios from "axios";
import { DropDownItem } from "@/services/DropDownItem";

export class SignSelectOption {
    public id: string;
    public idCountry: string;
    public idChannel: number;
    public level: number;
    public typeOfProposal: string;
    public signCustomization: string;
    public signType: string;
    public signSize: string;
    public signBrandCustomization: string;
    public deletionDate: Date;
}

let SIGN_SELECT_OPTIONS: Array<SignSelectOption> = [];
let mainVar: MainVar;


async function SyncSignSelectOptions() {    
    let firstLoad: boolean = false;
    if(mainVar == null) {
        mainVar = new MainVar();
        await mainVar.GetAsync();
        firstLoad = true;
    }
    
    if(firstLoad || SIGN_SELECT_OPTIONS.length == 0) {
        await getSignSelectOptions();
    } else {
        let previousMainVar = new MainVar();
        previousMainVar.dropDownListLastUpdate = mainVar.dropDownListLastUpdate;
        previousMainVar.translationsLastUpdate = mainVar.translationsLastUpdate;
        previousMainVar.lastEndpointCheck = mainVar.lastEndpointCheck;

        await mainVar.GetAsync();
        if(mainVar.IsRecent(previousMainVar)) {    
            await getSignSelectOptions();
        }
    }
}

async function getSignSelectOptions(): Promise<SignSelectOption[]> {
    let response = await axios.get<SignSelectOption[]>(
        General.GetApiUrl('/api/net20/GetSignSelectOptions'),{
        responseType: "json",
        withCredentials: true
    });
    if(response.data)
        SIGN_SELECT_OPTIONS = response.data;

    return SIGN_SELECT_OPTIONS;
}

export enum LEVEL {
    SIGN_CUSTOMIZATION = 1,
    SIGN_TYPE = 2,
    SIGN_SIZE = 3,
    SIGN_BRAND_CUSTOMIZATION = 4,
}

export async function isDepractedSignCustomization(selectOption: SignSelectOption): Promise<boolean> {
    let check = false;
    await SyncSignSelectOptions();

    let counter = SIGN_SELECT_OPTIONS.filter(s => (s.idCountry == null || s.idCountry === selectOption.idCountry)
        && s.idChannel == selectOption.idChannel
        && s.typeOfProposal === selectOption.typeOfProposal
        && s.signCustomization === selectOption.signCustomization
        && s.signType === selectOption.signType
        && s.signSize === selectOption.signSize
        && s.signBrandCustomization === selectOption.signBrandCustomization
        && s.deletionDate != null).length;
    if(counter > 0)
        check = true;

    return check;
}

export async function getDropDownIdList(selectOption: SignSelectOption, selectedValue: string): Promise<Array<DropDownItem>> {
    await SyncSignSelectOptions();
    let idList: Array<DropDownItem> = new Array<DropDownItem>();
    let filteredOptions = SIGN_SELECT_OPTIONS.filter(s => (s.idCountry == null || s.idCountry === selectOption.idCountry)
                                                            && s.idChannel == selectOption.idChannel
                                                            && s.typeOfProposal === selectOption.typeOfProposal
                                                            && (!selectOption.signCustomization || s.signCustomization === selectOption.signCustomization)
                                                            && (!selectOption.signType || s.signType === selectOption.signType)
                                                            && (!selectOption.signSize || s.signSize === selectOption.signSize)
                                                            && (!selectOption.signBrandCustomization || s.signBrandCustomization === selectOption.signBrandCustomization));

    switch(selectOption.level) {
        case LEVEL.SIGN_CUSTOMIZATION: {
            idList = filteredOptions.filter(s => s.deletionDate == null || (s.deletionDate != null && s.signCustomization === selectedValue)).map(s => <DropDownItem>({
                idDropDownItem: s.signCustomization,
                deletionDate: s.deletionDate
                }));
            break;
        }
        case LEVEL.SIGN_TYPE: {
            idList = filteredOptions.filter(s => s.deletionDate == null || (s.deletionDate != null && s.signType === selectedValue)).map(s => <DropDownItem>({
                idDropDownItem: s.signType,
                deletionDate: s.deletionDate
                }));
            break;
        }
        case LEVEL.SIGN_SIZE: {
            idList = filteredOptions.filter(s => s.deletionDate == null || (s.deletionDate != null && s.signSize === selectedValue)).map(s => <DropDownItem>({
                idDropDownItem: s.signSize,
                deletionDate: s.deletionDate
                }));
            break;
        }
        case LEVEL.SIGN_BRAND_CUSTOMIZATION: {
            idList = filteredOptions.filter(s => s.deletionDate == null || (s.deletionDate != null && s.signBrandCustomization === selectedValue)).map(s => <DropDownItem>({
                idDropDownItem: s.signBrandCustomization,
                deletionDate: s.deletionDate
                }));
            break;
        }
    }
    
    return idList;
}